import { render } from "./register-page.vue?vue&type=template&id=044970a4&scoped=true"
import script from "./register-page.vue?vue&type=script&lang=js"
export * from "./register-page.vue?vue&type=script&lang=js"

import "./register-page.vue?vue&type=style&index=0&id=044970a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044970a4"]])

export default __exports__